module.exports = __webpack_public_path__ + "img/ISO27001-en.28a04d48.jpg";